/**
 * The signed-in trader as the shell writes them. There is no profile endpoint
 * yet, so both places that show a name — the sidebar's account card and the
 * phone's account sheet — read the session and fall back to the fixture.
 */

/**
 * The trader's name as the admin and Profile have it: `first_name last_name`
 * from /v3/user/profile/details/. Until that answers, the session's
 * `displayName`, then the email's local part (Firebase sends "" for no name).
 */
export const displayNameOf = (user, fallback, profile) => {
  const profileName = [profile?.first_name, profile?.last_name]
    .map((part) => String(part ?? '').trim())
    .filter(Boolean)
    .join(' ');
  return profileName || (user?.name ?? '').trim() || user?.email?.split('@')[0] || fallback;
};

/** The avatar is a single letter, and an empty name would draw an empty circle. */
export const initialOf = (name) => (name || '?').trim().charAt(0).toUpperCase();
